import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>Steps 1 and 2 are best approached with an open and reflective
                                                thought process so it helps for you to be in the right frame
                                                of mind. The next section will describe ways to break us out
                                                of an unsuitable frame of mind so we are able to effectively
                                                reframe challenges.</p>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">HOW TO STOP CURRENT THOUGHT PROCESSES</span>
                                            </div>
                                            <p>Everyday activities can put you in a narrow and un-creative
                                                state of thinking, and sometimes taking a small step away
                                                from work can, in fact, help you tackle it better. A book by
                                                C. Barez- Brown explains some easy and productive breaks
                                                that can help you ‘break-out’ from an unimaginative rut.
                                                Some of his helpful tips are listed below.</p>
                                            <div className="border_subtitle">State breakers<a
                                                className="superscripttext boldlink"
                                                href="further_info.php?page=1&amp;course=300"><sup>3</sup></a>
                                            </div>
                                            <table width="100%" cellSpacing="0" cellPadding="0" border="0"
                                                   className="ilead_v_sport uiheading">
                                                <tbody>
                                                <tr>
                                                    <th valign="top" align="left"
                                                        className="green_curve">What is it?
                                                    </th>
                                                    <th valign="top" align="left"
                                                        className="green_curve1">How does it work?
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td valign="top" align="left" className="lightgreen"><p>
                                                        <span className="subtiltereg">Get physical – go for a walk, make a cup of tea</span>
                                                    </p></td>
                                                    <td valign="top" align="left" className="lightgreen">
                                                        <ul className="greenbullet-list">
                                                            <li><p>Changing your physical surroundings
                                                                stimulates you visually and physically.</p>
                                                            </li>
                                                            <li><p>By focusing on something else you can
                                                                free your mind from obstructing
                                                                thoughts.</p></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top" align="left" className="darkgreen"><p>
                                                        <span
                                                            className="subtiltereg">Count your blessings exercise</span>
                                                    </p></td>
                                                    <td valign="top" align="left" className="darkgreen">
                                                        <ul className="greenbullet-list">
                                                            <li><p>Without censoring your thoughts just note
                                                                down anything and everything you can think
                                                                of that’s working well in your life, or that
                                                                you appreciate.</p></li>
                                                            <li><p>Read the list back and notice if and how
                                                                your mood changes.</p></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top" align="left" className="lightgreen"><p>
                                                                    <span
                                                                        className="subtiltereg">Use a ‘park board’</span>
                                                    </p></td>
                                                    <td valign="top" align="left" className="lightgreen">
                                                        <ul className="greenbullet-list">
                                                            <li><p>On an individual or group basis capture,
                                                                on a flip chart or note pad, all of the
                                                                nagging doubts/creative ‘blockers’ you’re
                                                                thinking about that are dominating your
                                                                thoughts and obstructing new ones.</p></li>
                                                            <li><p>Seal the list in an envelope,
                                                                psychologically ‘park’ them and block their
                                                                recurrence until you give yourself
                                                                permission to re-open the envelope
                                                                later.</p></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top" align="left" className="darkgreen"><p>
                                                                    <span
                                                                        className="subtiltereg">Reframe the situation</span>
                                                    </p></td>
                                                    <td valign="top" align="left" className="darkgreen">
                                                        <ul className="greenbullet-list">
                                                            <li><p>Write down all your feelings and concerns
                                                                about the issue and your reasons for
                                                                them.</p></li>
                                                            <li><p>Reconsider what you’ve written, later,
                                                                from a more positive – or even an amusing –
                                                                perspective.</p></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top" align="left" className="lightgreen"><p>
                                                        <span className="subtiltereg">Ask yourself some weighty questions</span>
                                                    </p></td>
                                                    <td valign="top" align="left"
                                                        className="lightgreen paraspace"><p>In order to
                                                        connect with your personal ‘motivators’ ask yourself
                                                        the following:
                                                    </p>
                                                        <ul className="greenbullet-list">
                                                            <li><p>What in life do you want to achieve?</p>
                                                            </li>
                                                            <li><p>What do you want to be remembered
                                                                for?</p></li>
                                                            <li><p>What impact would you like to have on the
                                                                world?</p></li>
                                                            <li><p>What are your passions?</p></li>
                                                            <li><p>What would you like to learn?</p></li>
                                                        </ul>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">BEGIN TO REFRAME PROBLEMS</span>
                                            </div>
                                            <p>The first step when reframing any problem is to recognise
                                                where the difficulty or opportunity is. Once you have
                                                identified the issue take some time to understand the nature
                                                of the problem or opportunity.</p>
                                            <div className="border_subtitle">Insight</div>
                                            <p>Once you’ve managed to put your usual thoughts about the
                                                issue on hold, try one of the following ways to generate
                                                other ideas or insights:</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}